import Axios from "../utils/axios";

const axios = new Axios();

export type InvoiceAuditAction = "created" | "edited" | "sent" | "cancelled";

export type InvoiceAuditSendMode = "real" | "test";

export type InvoiceAuditDocType = "invoice" | "payment";

export interface InvoiceAuditFieldChange {
  field: string;
  from: string | number | null;
  to: string | number | null;
}

export interface InvoiceAuditConcept {
  concept: string;
  amount: number;
}

export interface InvoiceAuditLogPayload {
  billingDocId: string;
  billingDocType: InvoiceAuditDocType;
  partyKey?: string;
  partyId?: string;
  officeId?: string | null;
  firmId?: string | null;
  invoiceNumber?: string;
  contextKind?: string;
  action: InvoiceAuditAction;
  sendMode?: InvoiceAuditSendMode;
  recipients?: string[];
  /** Field-level before/after diff for edit events. */
  changes?: InvoiceAuditFieldChange[];
  /** Concepts paid and their amounts (for payment create/edit events). */
  concepts?: InvoiceAuditConcept[];
  detail?: string;
  performedAt: string;
  performedById: string;
  performedByName: string;
  performedByEmail?: string;
}

export interface InvoiceAuditLogDoc extends InvoiceAuditLogPayload {
  id: string;
  createdDate?: number;
  _ts?: number;
}

export const logInvoiceEvent = async (
  payload: InvoiceAuditLogPayload,
): Promise<{ success: boolean; id?: string }> => {
  const response = await axios.Post("/invoice-audit-log", payload);
  return response.data;
};

export const getInvoiceAuditLogs = async (
  officeId: string,
  limit = 100,
): Promise<InvoiceAuditLogDoc[]> => {
  if (!officeId) {
    return [];
  }
  try {
    const params = new URLSearchParams();
    params.append(
      "filter",
      JSON.stringify({
        officeId: { value: officeId, comparisonType: "EQUAL" },
      }),
    );
    params.append("sort", JSON.stringify({ field: "performedAt", order: "desc" }));
    params.append(
      "pagination",
      JSON.stringify({ pageIndex: 0, pageSize: limit }),
    );
    const response = await axios.Get(
      `/invoice-audit-log?${params.toString()}`,
    );
    return Array.isArray(response.data)
      ? (response.data as InvoiceAuditLogDoc[])
      : [];
  } catch {
    return [];
  }
};
